<template>
  <div class>
    <aside>
      <article class="gallery-wrap">
        <div class="img-big-wrap">
          <div style=" align-items:center;" class="text-center image-align" ref="imageContainer">
            <inner-image-zoom style class="mx-auto imgzoom" :src="currentImage" />
            <!-- <input type="checkbox" id="zoomCheck" /> -->
            <!-- <label for="zoomCheck"> -->
            <!-- <v-zoomer style=" border: solid 1px silver;"> -->
            <!-- <img :src="currentImage" style class="mx-auto" /> -->
            <!-- </v-zoomer> -->
            <!-- </label> -->
          </div>
        </div>
        <!-- <div class="img-small-wrap">
          <div v-for="(slide, i) in slides" :key="i" class="item-gallery" @click="changeImage(i)">
            <img :src="slide" />
          </div>
        </div> -->
      </article>
    </aside>
  </div>
</template>

<script>
import InnerImageZoom from "vue-inner-image-zoom";

export default {
  components: {
    InnerImageZoom,
  },
  props: {
    slides: Array,
    pindex: Number
  },
  data() {
    return {
      currentImage: this.$props.slides[this.pindex],
      pind: this.pindex
    };
  },
  created(){
    console.log(this.pind);
  },
  methods: {
    changeImage(n) {
      this.currentImage = this.$props.slides[n];
    }
  },
};
</script>

<style scoped>
/* .gallery-wrap .img-big-wrap img {
  height: 750px;
  width: auto;
  display: inline-block;
} */
.image-magnifier.ml-5 {
  width: 40%;
}
/* .gallery-wrap .img-small-wrap .item-gallery {
  width: 60px;
  height: 60px;
  border: 1px solid #ddd;
  margin: 7px 2px;
  display: inline-block;
}
.gallery-wrap .img-small-wrap {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  /* flex-flow: column nowrap; */
  /*justify-content: center; 
  align-items: flex-end; /* aligns on horizontal for column 


} 
*/
/* .gallery-wrap .img-small-wrap img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
} */
/* picture {
  display: flex !important;
  height: 12px !important;
} */
.image-align {
  margin-top: 150px;
}
.iiz {
  max-width: 39.5%;
  overflow:visible !important;
}

@media(max-width:470px){

  .v--modal-overlay .v--modal-box{
    position: static !important;
  }

}

@media(max-width:450px){
  .iiz {
    max-width: 90%;
  overflow:visible !important;
}
.v--modal-overlay .v--modal-box{
    position: static !important;
  }

}

.imgzoom{
  /* position: absolute; */
  z-index: 1000;
}
</style>
